<template>
  <UikitDialog
    :model-value="modelValue"
    position="right"
    full-height
    content-class="osk-yandex-pay-info-dialog"
    @update:model-value="onCloseDialog"
  >
    <ProductYandexPayInfo :split="split" />

    <div class="osk-yandex-pay-info-dialog__back-to-product">
      <UikitButton
        full-width
        @click="backToProductClick"
      >
        Вернуться к товару
      </UikitButton>
    </div>
  </UikitDialog>
</template>

<script lang="ts" setup>
import { SplitInfo } from '~/restAPI/data-contracts';
import { AnalyticsEvents, AnalyticsPages } from '~/types/analytics';

const props = defineProps<{
  modelValue: boolean,
  split?: SplitInfo
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void,
}>();

const { $addEvent } = useNuxtApp();

function backToProductClick() {
  $addEvent(AnalyticsEvents.YandexSplitInfoBackToItem, {
    page: AnalyticsPages.InfoSplit,
  });

  emit('update:modelValue', false);
}

function onCloseDialog() {
  $addEvent(AnalyticsEvents.YandexSplitInfoClose, {
    page: AnalyticsPages.InfoSplit,
  });

  emit('update:modelValue', false);
}
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-yandex-pay-info-dialog {

  .osk-dialog__close {
    @include media-query(sm-and-down) {
      top: 24px;
      right: 16px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        color: $white;
      }

      &::before {
        content: '';
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
        background-color: $primary;
        opacity: .15;
      }

    }

    @include media-query(md-and-up) {
      top: 44px;
      right: 52px;
    }
  }

  &.osk-dialog__body {
    @include media-query(sm-and-down) {
      padding: 0 0 62px;
    }
  }

  &__back-to-product {
    @include media-query(sm-and-down) {
      position: fixed;
      bottom: 0;
      padding: 0 16px 16px;
      left: 0;
      right: 0;
      background-color: $white;
    }

    @include media-query(md-and-up) {
      margin: 32px 28px 0;
      display: block;
    }
  }
}
</style>
